import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_GETOTP_FULFILLED = "FETCH_GETOTP_FULFILLED";
export const FETCH_GETOTP_REJECTED = "FETCH_GETOTP_REJECTED";
export const FETCH_GETOTP_PENDING = "FETCH_GETOTP_PENDING";
export const RESET_GETOTP = "RESET_GETOTP";


export function getOtp() {
  const token = localStorage.getItem("accessToken")
  return dispatch => {
    dispatch({
      type: "FETCH_GETOTP",
      payload: axios({
        method: "GET",
        url: `${API_BASE}/api/v3/second-opinion/send-agreement-approval-otp`,

        headers: {
          "Authorization": "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning" : "69920"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetGetOtp() {
  return (dispatch) => {
      dispatch({
          type: "RESET_GETOTP",
      });
  };
}